module.exports = __webpack_public_path__ + "static/media/login.3c11897e.png";